import { render, staticRenderFns } from "./aboutJpc.vue?vue&type=template&id=39b38308"
import script from "./aboutJpc.vue?vue&type=script&lang=js"
export * from "./aboutJpc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports